module.exports = __webpack_public_path__ + "img/portfolio--agency-01.714907cd.jpg";